import { useState } from "react";
export const find = (term, collection, params = {}) => {
    const { caseSensitive = false, matchPrefix = false, minimum = 3, limit = 200 } = params;
    if (term.length < minimum)
        return collection;
    const escapedTerm = term.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    const rexp = new RegExp(`${matchPrefix ? "(^|\\s)" : ""}${escapedTerm}`, caseSensitive ? undefined : "i");
    return collection.reduce((prev, { title, indeterminate, items }) => [
        ...prev,
        { indeterminate, items: items.filter(({ value }) => value === null || value === void 0 ? void 0 : value.match(rexp)).slice(0, limit), title },
    ], []);
};
export const useFinder = (collection) => {
    const [baseCol, setBaseCol] = useState(collection);
    const reset = () => setBaseCol(collection);
    const innerFind = (term, params) => setBaseCol(find(term, collection, params));
    return { collection: baseCol, find: innerFind, reset };
};
export const Finder = ({ collection, children }) => {
    const { collection: baseCol, find: innerFind, reset } = useFinder(collection);
    return children({
        collection: baseCol,
        find: innerFind,
        reset,
    });
};
